/* eslint-disable class-methods-use-this */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-empty-interface, @typescript-eslint/no-misused-promises */
/* eslint-disable max-len, react/function-component-definition */
/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import { confirmWrapper } from 'src/components/Dialog';
import withRouter from '../../hooks/withRouter';

import {
  JobDetailProps,
  JobDetails,
  JobDetailState,
  JobDetailViewRendererProps,
} from './types';
import API from '../../network';

import ViewRenderer from './views';
import { extractLastDigit, stripHtml } from './utils';
import ApplyJob from './components/ApplyJob';
import ShareJob from './components/ShareJob';

class JobDetail extends Component<JobDetailProps, JobDetailState> {
  constructor(props: JobDetailProps) {
    super(props);
    this.state = {
      loading: false,
      fetchingJobDetails: false,
      jobDetails: null,
      jobOrderId: 0,
      orgId: 0,
      resumePath: '',
      candidateEmail: '',
      submitting: false,
      candidateId: '',
    };
  }

  componentDidMount() {
    this.fetchJobDetails();
  }

  fetchJobDetails = async () => {
    this.setState({
      loading: true,
      fetchingJobDetails: true,
    });
    const { router } = this.props;
    const { jobSlug, orgId } = router?.params ?? {};

    const jobOrderId = extractLastDigit(jobSlug as string);

    try {
      const response: JobDetails = await API.getInstance().getJobDetailsByJobOrderId(Number(jobOrderId));
      this.setState({
        jobDetails: response,
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        loading: false,
        fetchingJobDetails: false,
        orgId: Number(orgId),
        jobOrderId: Number(jobOrderId),
      });
    }
  };

  shareJob = async () => {
    const { jobDetails } = this.state;
    await confirmWrapper(
      '',
      {
        variant: '',
        hidePrimaryBtn: true,
        hideSecondaryBtn: true,
        fullWidth: true,
        maxWidth: 'dialogSmall',
        containerClasses: 'pt-0 px-6',
        showCloseButton: true,
        dialogContent: (
          <ShareJob
            jobTitle={jobDetails?.jobTitle as string}
          />
        ),
      },
    );
  };

  applyJob = async () => {
    const { jobDetails, jobOrderId, orgId } = this.state;
    const jdText = stripHtml(jobDetails?.jobDescription || '');
    await confirmWrapper(
      '',
      {
        variant: '',
        hidePrimaryBtn: true,
        hideSecondaryBtn: true,
        fullWidth: true,
        maxWidth: 'dialogSmall',
        containerClasses: 'pt-0 px-6',
        disableBackdropClickClose: true,
        disableEscapeKeyDownClose: true,
        showCloseButton: true,
        dialogContent: (
          <ApplyJob
            jobTitle={jobDetails?.jobTitle as string}
            jdText={jdText}
            jobOrderId={jobOrderId}
            orgId={orgId}
          />
        ),
      },
    );
  };

  getProps = (): JobDetailViewRendererProps => {
    const {
      loading,
      jobDetails,
      fetchingJobDetails,
      jobOrderId,
      orgId,
      resumePath,
      candidateEmail,
      submitting,
      candidateId,
    } = this.state;

    return {
      candidateId,
      jobDetails,
      candidateEmail,
      loading,
      fetchingJobDetails,
      orgId,
      jobOrderId,
      submitting,
      resumePath,
      onApplyJob: this.applyJob,
      shareJob: this.shareJob,
    };
  };

  render() {
    const viewProps: JobDetailViewRendererProps = this.getProps();

    return (
      <ViewRenderer {...viewProps} />
    );
  }
}

export default withRouter(JobDetail);
